import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./MobileHamburgerMenu.scss";

function MobileHamburgerMenu() {
  const [open, setOpen] = useState(false);

  const links = [
    { label: "About", to: "/about" },
    { label: "Development", to: "/development" },
    { label: "Music", to: "/music" },
    { label: "Contact", to: "/contact" },
  ];

  return (
    <div className="mobile-nav">
      <div className="mobile-nav-button-container">
        <div
          className="mobile-nav-button"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          <span
            className="mobile-nav-button-line"
            style={{
              transform: open ? "rotate(45deg) translateY(6px)" : "none",
            }}
          />
          <span
            className="mobile-nav-button-line"
            style={{
              opacity: open ? 0 : 1,
            }}
          />
          <span
            className="mobile-nav-button-line"
            style={{
              transform: open ? "rotate(-45deg) translateY(-6px)" : "none",
            }}
          />
        </div>
      </div>

      <div
        className="mobile-nav-dropdown"
        style={{
          maxHeight: open ? "240px" : "0",
        }}
      >
        <nav className="mobile-nav-menu">
          {links.map((link, i) => (
            <Link
              key={i}
              to={link.to}
              className="mobile-nav-link"
              onClick={() => setOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  );
}

export default MobileHamburgerMenu;
